import { useMemo, useEffect } from 'react'
import { getBillingInformationForm } from '../schema'
import { useUtils } from '@pepper/ui'
import clsx from 'clsx'
import { FormikProps } from 'formik'
/* @pepper/utils */
import { findLocationByZipCode } from '@pepper/utils/src/api/users/users'

import { getFieldComponent } from 'components/FormFields/FormFields'

import styles from '../_.module.css'

interface Props {
  totalPrice: PayScale
  formikProps: FormikProps<SmeBillingInformation>
}

const BillingForm = ({
  formikProps: props,
  totalPrice,
}: Props): JSX.Element => {
  const { timezones } = useUtils()

  /* This function will return state according to zip code */
  const fetchStateFromZipcode = async (zipCode: string) => {
    if (zipCode && totalPrice?.currency === 1) {
      try {
        const { data, status } = await findLocationByZipCode({ zipCode })
        if (status === 'ok') {
          props.setFieldValue('state', data?.[0]?.PostOffice?.[0]?.State)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  useEffect(() => {
    if (!props.values.zip_code) {
      props.setFieldValue('state', '')
      return
    }
    fetchStateFromZipcode(props.values.zip_code)
  }, [props.values.zip_code])

  /* Fetching country code */
  const countryCode = useMemo(() => {
    const getCountryCode = Array.from(
      new Set(timezones.map(code => code.country_code))
    ).map(id => {
      return {
        value: id,
        label: timezones.find(label => label.country_code === id)?.country_name,
      }
    })
    return getCountryCode
  }, [timezones])

  return (
    <section
      className={clsx(styles.formDisplayBilling, 'd-grid-24', styles.gridBill)}
    >
      {getBillingInformationForm(countryCode, totalPrice?.currency || 1).map(
        field => (
          <div key={field.name} className={field.grid}>
            {getFieldComponent({
              className: styles.displayWrap,
              type: field.type,
              name: field.name,
              label: field.label,
              required: field.required,
              fieldProps: field.fieldProps,
              actions: props,
            })}
          </div>
        )
      )}
    </section>
  )
}

export default BillingForm
